import history from '../../util/history'

const toEditView = reservationId => {
  history.push(`/reservation/${reservationId}/edit`)

  return true
}

export default toEditView
